import { Box, Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

import { useAuth } from '@repo/common/queries/auth'
import { useListPortfolio } from '@repo/common/queries/portfolio'

import { ContentBox } from '@/components/ContentBox'
import { HeadlineAndDetails } from '@/components/HeadlineAndDetails'
import { LinkButton } from '@/components/LinkButton'
import { PortfolioChart } from '@/components/PortfolioChart'
import { PortfolioLedger } from '@/components/PortfolioLedger'
import { PortfolioReturnMetrics } from '@/components/PortfolioReturnMetrics'
import { PortfolioTable } from '@/components/PortfolioTable'

// do to TanStack Router auto generate file routes
// prettier-ignore
export const Route = createFileRoute('/_app/portfolio')({
  component: IndexPage,
})

function IndexPage() {
  const auth = useAuth()

  const { totals } = useListPortfolio()

  const newbie = totals.tokens == 0

  if (newbie) {
    return (
      <Stack gap="xl">
        <HeadlineAndDetails
          title="Portfolio"
          description="Want a portfolio of tokenized real world investments?"
        />
        <ContentBox w="100%" variant="fading" p="xl">
          <Box>
            <LinkButton to="/investments" variant="button">
              Buy Now
            </LinkButton>
          </Box>
        </ContentBox>
      </Stack>
    )
  }

  return (
    <Stack gap="xl">
      <HeadlineAndDetails
        title="Portfolio"
        description={auth.switch(
          '',
          'Please connect your wallet to view your portfolio.',
        )}
      />
      <ContentBox
        w="100%"
        variant="fading"
        h="450px"
        pl="xxs"
        pt="lg"
        pr="lg"
        pb="xxs"
      >
        <PortfolioChart />
      </ContentBox>
      <ContentBox w="100%" variant="fading" p="xl">
        <PortfolioReturnMetrics />
      </ContentBox>

      <ContentBox w="100%" variant="fading" p="xl">
        <PortfolioTable />
      </ContentBox>

      <ContentBox w="100%" variant="fading" p="xl">
        <PortfolioLedger />
      </ContentBox>
    </Stack>
  )
}
